import * as React from 'react';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

const StySwitchButton = styled(Button, {
    name: 'StySwitchButton',
    shouldForwardProp: (prop) => prop !== 'toLeft',
})<{ toLeft: boolean }>(({ toLeft, theme }) => ({
    borderRadius: 4,
    boxShadow: 'none',
    transition:
        'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',

    minHeight: '1.5rem',
    maxHeight: '1.5rem',
    minWidth: '1.5rem',
    maxWidth: '1.5rem',

    color: 'white',
    background: theme.palette.primary.main,
    '&:hover': {
        background: 'white',
        color: theme.palette.primary.main,
    },

    transform: toLeft ? 'rotate(180deg)' : '',
}));

/**
 * Button to expand or reduce the side bar.
 */
const SwitchButton = (props: {
    isSideBarModeAlwaysExpanded: boolean;
    toggleSideBarMode: () => void;
}): React.ReactElement => (
    <StySwitchButton
        toLeft={props.isSideBarModeAlwaysExpanded}
        onClick={props.toggleSideBarMode}
    >
        <DoubleArrowIcon fontSize="small" />
    </StySwitchButton>
);
export { SwitchButton };
